import type { SVGProps } from 'react';

const SvgHeartCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.333 12.333a4 4 0 0 0-4 4c0 .75.209 1.459.584 2.059a3.973 3.973 0 0 0 3.416 1.941 3.963 3.963 0 0 0 3.417-1.941c.367-.6.583-1.309.583-2.059 0-2.208-1.791-4-4-4Zm1.984 3.475-2.134 1.967a.635.635 0 0 1-.425.167.618.618 0 0 1-.441-.184l-.984-.983a.629.629 0 0 1 0-.883.629.629 0 0 1 .884 0l.558.558 1.692-1.567a.63.63 0 0 1 .883.034.64.64 0 0 1-.033.891Z'
      fill='currentColor'
    />
    <path
      d='M20.333 9.275c0 .992-.158 1.908-.433 2.758-.05.175-.258.225-.408.117a5.289 5.289 0 0 0-3.159-1.033 5.26 5.26 0 0 0-5.25 5.25c0 .9.234 1.783.675 2.566.134.234-.025.534-.275.442-2.008-.683-6.066-3.175-7.383-7.342a8.899 8.899 0 0 1-.433-2.758c0-2.575 2.075-4.658 4.633-4.658 1.508 0 2.858.733 3.7 1.858a4.624 4.624 0 0 1 3.7-1.858c2.558 0 4.633 2.083 4.633 4.658Z'
      fill='currentColor'
      opacity={0.4}
    />
  </svg>
);
export default SvgHeartCheck;
